import Vue from 'vue';
import Router from 'vue-router';
import queryString from 'query-string';
import store from './store';

import Home from './views/Home.vue';
import Login from './views/Login.vue';
import Detail from './views/Detail.vue';
import Overview from './views/Overview';
import Dashboard from './views/Dashboard.vue';
import UserManagement from './views/UserManagement.vue';
import ThesisManagement from './views/ThesisManagement.vue';
import Report from './views/Report';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        title: 'Úvod'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        title: 'Přihlásit se'
      }
    },
    {
      path: '/detail',
      name: 'detail',
      component: Detail,
      meta: {
        requiresRoles: ['student'],
        title: 'Maturitní práce'
      }
    },
    {
      path: '/overview',
      name: 'overview',
      component: Overview,
      meta: {
        requiresRoles: ['teacher'],
        title: 'Přehled maturitních prací'
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        requiresRoles: ['admin'],
        title: 'Přehled maturitních prací'
      }
    },
    {
      path: '/users',
      name: 'user-management',
      component: UserManagement,
      meta: {
        requiresRoles: ['admin'],
        title: 'Správa uživatelů'
      }
    },
    {
      path: '/theses',
      name: 'thesis-management',
      component: ThesisManagement,
      meta: {
        requiresRoles: ['admin'],
        title: 'Správa maturitních prací'
      }
    },
    {
      path: '/report',
      name: 'report',
      component: Report,
      meta: {
        requiresRoles: ['admin', 'teacher', 'student'],
        title: 'Posudek maturitní práce'
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  const { userRole } = store.getters;

  const hasRole = to.matched.every(
    ({ meta: { requiresRoles } }) =>
      !requiresRoles || (requiresRoles && requiresRoles.includes(userRole))
  );

  if (!userRole && !hasRole) {
    const query = queryString.stringify({ redirect: to.fullPath });
    return next(`/login?${query}`);
  }

  if (!hasRole) {
    return next(from.path);
  }

  if (to.query.author) {
    document.title = `Posudek ${
      to.query.author === 'supervisor'
        ? 'vedoucího'
        : to.query.author === 'reader'
        ? 'oponenta'
        : ''
    } maturitní práce — Theses`;
  } else {
    document.title = `${to.meta.title} — Theses`;
  }

  return next();
});

export default router;
